export const INBOUND_ROUTE_ROOT = '/inbound';

export const INBOUND_ROUTES = {
  INBOUND: INBOUND_ROUTE_ROOT,
  ASSIGN: `${INBOUND_ROUTE_ROOT}/assign`,
  LIST: `${INBOUND_ROUTE_ROOT}/list`,
  ITEM: `${INBOUND_ROUTE_ROOT}/item`,
  SUMMARY: `${INBOUND_ROUTE_ROOT}/summary`,
  APPROVAL_LIST: `${INBOUND_ROUTE_ROOT}/approval-list`,
  APPROVAL: `${INBOUND_ROUTE_ROOT}/approval`,
} as const;
